import { ArrowRight } from "lucide-react";
import "./ServiceCard.css";

const ServiceCard = ({ icon: Icon, title, description, link }) => {
  return (
    <div className="service-card">

      <div className="service-icon">
        <Icon size={30} />
      </div>

      <h3>{title}</h3>

      <p>{description}</p>

      <a href={link} className="service-link">
        Learn More
        <ArrowRight size={18} />
      </a>

    </div>
  );
};

export default ServiceCard;